/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/** Prefix the matrix merge flows write onto a row's `changes` map for a superseded value. */
const ORIGINAL_VALUE_PREFIX = 'Original Value: ';

/** The original value carried by a merge change entry, or `''` when the entry is not one. */
export function extractMergeOriginalValue(changeEntry: string): string {
  if (!changeEntry || !changeEntry.startsWith(ORIGINAL_VALUE_PREFIX)) {
    return '';
  }
  return changeEntry.substring(ORIGINAL_VALUE_PREFIX.length);
}

/**
 * The cell content for a cadence merge preview: the current value, plus the superseded one alongside it
 * when there is one.
 *
 * <p>Returns an element rather than an HTML string because ag-grid assigns a string returned from
 * `cellRenderer` as `innerHTML`. Both values originate in the Device IO source data, so interpolating
 * them into markup would let a crafted name or description inject nodes into the grid.
 */
export function buildMergeCellElement(displayValue: string, originalValue: string): HTMLElement {
  const wrapper = document.createElement('span');
  if (!originalValue) {
    wrapper.textContent = displayValue;
    return wrapper;
  }
  wrapper.className = 'merge-cell-inline';
  wrapper.appendChild(buildValueSpan('merge-current-value', displayValue));
  wrapper.appendChild(buildValueSpan('merge-original-value', originalValue));
  return wrapper;
}

function buildValueSpan(className: string, value: string): HTMLElement {
  const span = document.createElement('span');
  span.className = className;
  span.textContent = value;
  return span;
}
